export const SEARCH_RESULTS_PATH = '(/beta)?/:channel(car|van|bike|caravan|motorhome|truck|plant|farm)-search'
export const RETAILER_STOCK_SEARCH_PATH =
    '/:channel(cars|vans|bikes|caravans|motorhomes|trucks|plant|farm)?/retailer/stock'

export const LEASING_SEARCH_PATH = '/:channel(car|van)-leasing-search'
